import { apiClient } from './api';
import { getActiveTenantId } from '@/store/tenantSelection';

export interface Tenant {
  tenant_id: string;
  name: string;
  status: string;
  config: Record<string, unknown>;
  created_at: string;
  updated_at: string;
}

export const tenantService = {
  async listTenants(): Promise<Tenant[]> {
    const response = await apiClient.get<Tenant[]>('/tenants');
    return response.data;
  },

  async getCurrentTenant(): Promise<Tenant> {
    const tenantResponse = await apiClient.get<Tenant>(`/tenants/${getActiveTenantId()}`);
    return tenantResponse.data;
  },

  async getTenantById(tenantId: string): Promise<Tenant> {
    const response = await apiClient.get<Tenant>(`/tenants/${tenantId}`);
    return response.data;
  }
};
